import React from "react";
import { Card, Form, Select, Spin, Table, Typography } from "antd";
import { Icon } from "Components";
import { ColumnsType } from "antd/es/table";
import { MappingSetting } from "../Mapping";

const { Title, Text } = Typography;

interface MappingTableContainerProps {
  selectedTenantId: string | null;
  isLoading: boolean;
  isSuperAdmin: boolean;
  setSelectedTenantId: (id: string) => void;
  TENANTS: { label: string; value: string }[];
  columns: ColumnsType<MappingSetting>;
  dataSource: MappingSetting[];
}

export const MappingTableContainer: React.FC<MappingTableContainerProps> = ({
  selectedTenantId,
  setSelectedTenantId,
  isLoading,
  TENANTS,
  isSuperAdmin,
  columns,
  dataSource,
}) => {

  return (
    <div className="bg-white pbx-24"
      style={{
        minHeight: "100vh",
        background: "white",
        padding: "24px"
      }}
    >
      <div className="mapping mw-1200 mx-auto">
        {/* Header Section */}
        <div className="mbx-24">
          <Title
            className="lh-15 fs-15 fw-500 card-foreground"
            level={3}
          >
            Mapping Settings
          </Title>
          <Text className="fs-1 text-muted-foreground fw-400">
            Manage property mapping configurations for third-party integrations.
          </Text>
        </div>

        {/* Tenant Selection Card */}
        <Card className="brx-10 mbx-24">
          <Title level={5} className="fw-400 mb-0">
            Select Tenant
          </Title>
          <Text type="secondary" className="text-muted-foreground fsx-14">
            Choose a tenant to view and manage their platform mappings.
          </Text>

          <Form layout="horizontal" className="mtx-24">
            <Form.Item
              label={<Text strong>Client</Text>}
              wrapperCol={{ span: 20 }}
              className="mb-0"
            >
              <Select
                showSearch
                disabled={!isSuperAdmin}
                placeholder="Select a tenant"
                value={selectedTenantId || undefined}
                onChange={(val) => setSelectedTenantId(val as string)}
                className="custom-select rounded-lg"
                dropdownClassName="custom-select-dropdown"
                suffixIcon={<Icon type="tenantSuffix" />}
                options={TENANTS}
                filterOption={(input, option) =>
                  String(option?.label).toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Form>
        </Card>

        {/* Platform Mappings Table */}
        <Card
          className="platform-mappings-card"
          title={
            <h4 className="fs-1 card-foreground fw-400">
              Platform Mappings
            </h4>
          }
          bordered
        >
          {selectedTenantId ? (
            <Spin spinning={isLoading}>
              <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                rowKey="key"
              />
            </Spin>
          ) : (
            <div className="pt-3 pb-3 text-center">
              <Text
                type="secondary" className="fs-1 text-muted-foreground"
              >
                Select a tenant to view platform mappings
              </Text>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};
